// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-details-container {
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
  position: relative;
}
.order-details-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  z-index: -1;
}
html[data-coreui-theme=dark] .order-details-container {
  background: linear-gradient(135deg, #1a1d24 0%, #2c3034 100%);
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .order-details-container::before {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
}
.order-details-container .order-details-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 400px;
  text-align: center;
  gap: 1rem;
}
.order-details-container .order-details-loading .order-details-spinner {
  width: 2.5rem;
  height: 2.5rem;
  animation: pulse 2s infinite;
}
.order-details-container .order-details-loading p {
  font-weight: 500;
  letter-spacing: 0.5px;
}
.order-details-container .order-details-error,
.order-details-container .order-details-not-found {
  padding: 2rem;
}
.order-details-container .order-details-error .error-alert,
.order-details-container .order-details-error .warning-alert,
.order-details-container .order-details-not-found .error-alert,
.order-details-container .order-details-not-found .warning-alert {
  border-radius: 0.5rem;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.order-details-container .order-details-error .error-alert:hover,
.order-details-container .order-details-error .warning-alert:hover,
.order-details-container .order-details-not-found .error-alert:hover,
.order-details-container .order-details-not-found .warning-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
}
.order-details-container .order-details-error .error-alert .alert-content,
.order-details-container .order-details-error .warning-alert .alert-content,
.order-details-container .order-details-not-found .error-alert .alert-content,
.order-details-container .order-details-not-found .warning-alert .alert-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 500;
}
.order-details-container .order-details-header {
  margin-bottom: 2rem;
}
.order-details-container .order-details-header .header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.order-details-container .order-details-header .header-left .back-button {
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}
.order-details-container .order-details-header .header-left .back-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}
.order-details-container .order-details-header .header-left .back-button:hover {
  transform: translateX(-3px);
}
.order-details-container .order-details-header .header-left .back-button:hover::before {
  left: 100%;
}
.order-details-container .order-details-header .header-left .header-title h3 {
  margin: 0;
  font-weight: 700;
  color: var(--cui-body-color, #2c3e50);
  font-size: clamp(1.5rem, 4vw, 2rem);
  letter-spacing: -0.5px;
}
.order-details-container .order-details-header .header-left .header-title .header-subtitle {
  color: var(--cui-secondary-color, #6c757d);
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 0.25rem;
  opacity: 0.8;
}
.order-details-container .order-summary-card {
  margin-bottom: 2rem;
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
}
.order-details-container .order-summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
}
.order-details-container .order-summary-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.order-details-container .order-summary-card .card-body {
  padding: 2rem;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 249, 250, 0.9) 100%);
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .card-body {
  background: linear-gradient(135deg, rgba(33, 38, 49, 0.9) 0%, rgba(44, 48, 52, 0.9) 100%);
}
.order-details-container .order-summary-card .order-info-section .order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}
.order-details-container .order-summary-card .order-info-section .order-header .order-title-section .order-title {
  margin: 0 0 0.5rem 0;
  font-weight: 700;
  color: var(--cui-body-color, #2c3e50);
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  letter-spacing: -0.5px;
}
.order-details-container .order-summary-card .order-info-section .order-header .order-title-section .order-title .icon {
  margin-right: 0.5rem;
  color: var(--cui-primary, #667eea);
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .order-info-section .order-header .order-title-section .order-title {
  color: var(--cui-body-color, #fff);
}
.order-details-container .order-summary-card .order-info-section .order-header .order-title-section .order-id {
  margin: 0;
  color: var(--cui-secondary-color, #6c757d);
  font-size: 0.875rem;
  font-weight: 500;
  font-family: "Monaco", "Menlo", monospace;
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .order-info-section .order-header .order-title-section .order-id {
  color: var(--cui-secondary-color, #8a93a2);
}
.order-details-container .order-summary-card .order-info-section .order-header .order-status-section .order-status-badge {
  font-weight: 600;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}
.order-details-container .order-summary-card .order-info-section .order-header .order-status-section .order-status-badge:hover {
  transform: scale(1.05);
}
.order-details-container .order-summary-card .order-info-section .order-basic-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}
.order-details-container .order-summary-card .order-info-section .order-basic-info .info-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.5);
}
.order-details-container .order-summary-card .order-info-section .order-basic-info .info-item:hover {
  background: rgba(102, 126, 234, 0.05);
  transform: translateX(2px);
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .order-info-section .order-basic-info .info-item {
  background: rgba(33, 38, 49, 0.5);
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .order-info-section .order-basic-info .info-item:hover {
  background: rgba(102, 126, 234, 0.1);
}
.order-details-container .order-summary-card .order-info-section .order-basic-info .info-item .info-icon {
  color: var(--cui-primary, #667eea);
  font-size: 1.1rem;
  min-width: 20px;
}
.order-details-container .order-summary-card .order-info-section .order-basic-info .info-item .info-text {
  color: var(--cui-body-color, #2c3e50);
  font-size: 0.875rem;
  line-height: 1.5;
}
.order-details-container .order-summary-card .order-info-section .order-basic-info .info-item .info-text strong {
  font-weight: 600;
  color: var(--cui-primary, #667eea);
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .order-info-section .order-basic-info .info-item .info-text {
  color: var(--cui-body-color, #fff);
}
.order-details-container .order-summary-card .order-summary-section {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  border-radius: 0.5rem;
  padding: 1.5rem;
}
.order-details-container .order-summary-card .order-summary-section .summary-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
  transition: all 0.2s ease;
}
.order-details-container .order-summary-card .order-summary-section .summary-item:hover {
  padding-left: 0.5rem;
  background: rgba(102, 126, 234, 0.02);
}
.order-details-container .order-summary-card .order-summary-section .summary-item:last-child {
  border-bottom: none;
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .order-summary-section .summary-item {
  border-bottom-color: rgba(102, 126, 234, 0.2);
}
.order-details-container .order-summary-card .order-summary-section .summary-item.total {
  border-top: 2px solid var(--cui-primary, #667eea);
  border-bottom: none;
  padding-top: 1.5rem;
  padding: 1.5rem;
  margin-top: 0.5rem;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 0.5rem;
}
.order-details-container .order-summary-card .order-summary-section .summary-item.total .summary-label,
.order-details-container .order-summary-card .order-summary-section .summary-item.total .summary-value {
  font-weight: 700;
  font-size: 1.2rem;
  color: var(--cui-primary, #667eea);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.order-details-container .order-summary-card .order-summary-section .summary-item .summary-label {
  color: var(--cui-secondary-color, #6c757d);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .order-summary-section .summary-item .summary-label {
  color: var(--cui-secondary-color, #8a93a2);
}
.order-details-container .order-summary-card .order-summary-section .summary-item .summary-value {
  color: var(--cui-body-color, #2c3e50);
  font-weight: 700;
  font-size: 1rem;
}
html[data-coreui-theme=dark] .order-details-container .order-summary-card .order-summary-section .summary-item .summary-value {
  color: var(--cui-body-color, #fff);
}
.order-details-container .order-details-tabs {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
}
.order-details-container .order-details-tabs:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
}
html[data-coreui-theme=dark] .order-details-container .order-details-tabs {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.order-details-container .order-details-tabs .tabs-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: none;
  padding: 0;
  position: relative;
}
.order-details-container .order-details-tabs .tabs-header::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}
.order-details-container .order-details-tabs .tabs-header .custom-tabs {
  border: none;
}
.order-details-container .order-details-tabs .tabs-header .custom-tabs .custom-tab-link {
  color: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 0;
  padding: 1.5rem 2rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  position: relative;
  text-transform: uppercase;
  font-size: 0.875rem;
}
.order-details-container .order-details-tabs .tabs-header .custom-tabs .custom-tab-link::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: left;
}
.order-details-container .order-details-tabs .tabs-header .custom-tabs .custom-tab-link:hover {
  color: white;
}
.order-details-container .order-details-tabs .tabs-header .custom-tabs .custom-tab-link:hover::before {
  transform: scaleX(1);
}
.order-details-container .order-details-tabs .tabs-header .custom-tabs .custom-tab-link.active {
  color: white;
  background-color: rgba(255, 255, 255, 0.15);
  border-bottom: 3px solid white;
}
.order-details-container .order-details-tabs .tabs-header .custom-tabs .custom-tab-link.active::before {
  transform: scaleX(1);
}
.order-details-container .order-details-tabs .tabs-header .custom-tabs .custom-tab-link .badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  margin-left: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.order-details-container .order-details-tabs .tabs-content {
  padding: 2rem;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 249, 250, 0.9) 100%);
}
html[data-coreui-theme=dark] .order-details-container .order-details-tabs .tabs-content {
  background: linear-gradient(135deg, rgba(33, 38, 49, 0.9) 0%, rgba(44, 48, 52, 0.9) 100%);
}
.order-details-container .order-details-tabs .tabs-content .info-card {
  border: none;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  overflow: hidden;
  transition: all 0.3s ease;
}
.order-details-container .order-details-tabs .tabs-content .info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
}
html[data-coreui-theme=dark] .order-details-container .order-details-tabs .tabs-content .info-card {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: none;
  padding: 1.5rem 2rem;
  position: relative;
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-card-header::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-card-header h6 {
  margin: 0;
  font-weight: 700;
  color: white;
  display: flex;
  align-items: center;
  font-size: 1rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-card-header h6 .icon {
  margin-right: 0.5rem;
}
.order-details-container .order-details-tabs .tabs-content .info-card .card-body {
  padding: 2rem;
  background: rgba(255, 255, 255, 0.8);
}
html[data-coreui-theme=dark] .order-details-container .order-details-tabs .tabs-content .info-card .card-body {
  background: rgba(33, 38, 49, 0.8);
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item {
  position: relative;
  padding: 1rem;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.6);
  transition: all 0.2s ease;
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item:hover {
  background: rgba(102, 126, 234, 0.05);
  transform: translateY(-2px);
}
html[data-coreui-theme=dark] .order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item {
  background: rgba(33, 38, 49, 0.6);
}
html[data-coreui-theme=dark] .order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item:hover {
  background: rgba(102, 126, 234, 0.1);
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item .info-label {
  display: block;
  font-weight: 700;
  color: var(--cui-primary, #667eea);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;
  position: relative;
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item .info-label::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 20px;
  height: 2px;
  background: var(--cui-primary, #667eea);
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item .info-value {
  color: var(--cui-body-color, #2c3e50);
  font-weight: 600;
  display: flex;
  align-items: center;
  font-size: 1rem;
  line-height: 1.4;
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item .info-value.total-price {
  font-weight: 700;
  color: var(--cui-success, #2eb85c);
  font-size: 1.2rem;
}
html[data-coreui-theme=dark] .order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item .info-value {
  color: var(--cui-body-color, #fff);
}
.order-details-container .order-details-tabs .tabs-content .info-card .info-grid .info-item .system-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.order-details-container .product-container .product-header,
.order-details-container .product-container .status-header,
.order-details-container .product-container .shipment-header,
.order-details-container .product-container .stock-header,
.order-details-container .status-container .product-header,
.order-details-container .status-container .status-header,
.order-details-container .status-container .shipment-header,
.order-details-container .status-container .stock-header,
.order-details-container .shipment-container .product-header,
.order-details-container .shipment-container .status-header,
.order-details-container .shipment-container .shipment-header,
.order-details-container .shipment-container .stock-header,
.order-details-container .stock-container .product-header,
.order-details-container .stock-container .status-header,
.order-details-container .stock-container .shipment-header,
.order-details-container .stock-container .stock-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}
.order-details-container .product-container .product-header h5,
.order-details-container .product-container .status-header h5,
.order-details-container .product-container .shipment-header h5,
.order-details-container .product-container .stock-header h5,
.order-details-container .status-container .product-header h5,
.order-details-container .status-container .status-header h5,
.order-details-container .status-container .shipment-header h5,
.order-details-container .status-container .stock-header h5,
.order-details-container .shipment-container .product-header h5,
.order-details-container .shipment-container .status-header h5,
.order-details-container .shipment-container .shipment-header h5,
.order-details-container .shipment-container .stock-header h5,
.order-details-container .stock-container .product-header h5,
.order-details-container .stock-container .status-header h5,
.order-details-container .stock-container .shipment-header h5,
.order-details-container .stock-container .stock-header h5 {
  margin: 0 0 0.5rem 0;
  font-weight: 700;
  color: var(--cui-body-color, #2c3e50);
  font-size: 1.5rem;
  letter-spacing: -0.5px;
}
html[data-coreui-theme=dark] .order-details-container .product-container .product-header h5,
html[data-coreui-theme=dark] .order-details-container .product-container .status-header h5,
html[data-coreui-theme=dark] .order-details-container .product-container .shipment-header h5,
html[data-coreui-theme=dark] .order-details-container .product-container .stock-header h5,
html[data-coreui-theme=dark] .order-details-container .status-container .product-header h5,
html[data-coreui-theme=dark] .order-details-container .status-container .status-header h5,
html[data-coreui-theme=dark] .order-details-container .status-container .shipment-header h5,
html[data-coreui-theme=dark] .order-details-container .status-container .stock-header h5,
html[data-coreui-theme=dark] .order-details-container .shipment-container .product-header h5,
html[data-coreui-theme=dark] .order-details-container .shipment-container .status-header h5,
html[data-coreui-theme=dark] .order-details-container .shipment-container .shipment-header h5,
html[data-coreui-theme=dark] .order-details-container .shipment-container .stock-header h5,
html[data-coreui-theme=dark] .order-details-container .stock-container .product-header h5,
html[data-coreui-theme=dark] .order-details-container .stock-container .status-header h5,
html[data-coreui-theme=dark] .order-details-container .stock-container .shipment-header h5,
html[data-coreui-theme=dark] .order-details-container .stock-container .stock-header h5 {
  color: var(--cui-body-color, #fff);
}
.order-details-container .product-container .product-header p,
.order-details-container .product-container .status-header p,
.order-details-container .product-container .shipment-header p,
.order-details-container .product-container .stock-header p,
.order-details-container .status-container .product-header p,
.order-details-container .status-container .status-header p,
.order-details-container .status-container .shipment-header p,
.order-details-container .status-container .stock-header p,
.order-details-container .shipment-container .product-header p,
.order-details-container .shipment-container .status-header p,
.order-details-container .shipment-container .shipment-header p,
.order-details-container .shipment-container .stock-header p,
.order-details-container .stock-container .product-header p,
.order-details-container .stock-container .status-header p,
.order-details-container .stock-container .shipment-header p,
.order-details-container .stock-container .stock-header p {
  margin: 0;
  color: var(--cui-secondary-color, #6c757d);
  font-size: 1rem;
  font-weight: 500;
}
html[data-coreui-theme=dark] .order-details-container .product-container .product-header p,
html[data-coreui-theme=dark] .order-details-container .product-container .status-header p,
html[data-coreui-theme=dark] .order-details-container .product-container .shipment-header p,
html[data-coreui-theme=dark] .order-details-container .product-container .stock-header p,
html[data-coreui-theme=dark] .order-details-container .status-container .product-header p,
html[data-coreui-theme=dark] .order-details-container .status-container .status-header p,
html[data-coreui-theme=dark] .order-details-container .status-container .shipment-header p,
html[data-coreui-theme=dark] .order-details-container .status-container .stock-header p,
html[data-coreui-theme=dark] .order-details-container .shipment-container .product-header p,
html[data-coreui-theme=dark] .order-details-container .shipment-container .status-header p,
html[data-coreui-theme=dark] .order-details-container .shipment-container .shipment-header p,
html[data-coreui-theme=dark] .order-details-container .shipment-container .stock-header p,
html[data-coreui-theme=dark] .order-details-container .stock-container .product-header p,
html[data-coreui-theme=dark] .order-details-container .stock-container .status-header p,
html[data-coreui-theme=dark] .order-details-container .stock-container .shipment-header p,
html[data-coreui-theme=dark] .order-details-container .stock-container .stock-header p {
  color: var(--cui-secondary-color, #8a93a2);
}
.order-details-container .product-container > .info-card,
.order-details-container .status-container > .info-card,
.order-details-container .shipment-container > .info-card,
.order-details-container .stock-container > .info-card {
  margin-bottom: 0;
}
.order-details-container .product-container .detail-totals-line,
.order-details-container .status-container .detail-totals-line,
.order-details-container .shipment-container .detail-totals-line,
.order-details-container .stock-container .detail-totals-line {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 0.5rem;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.07) 0%, rgba(118, 75, 162, 0.07) 100%);
  color: var(--cui-body-color, #2c3e50);
  font-size: 0.95rem;
  white-space: nowrap;
  overflow-x: auto;
}
.order-details-container .product-container .detail-totals-line .detail-total-item,
.order-details-container .status-container .detail-totals-line .detail-total-item,
.order-details-container .shipment-container .detail-totals-line .detail-total-item,
.order-details-container .stock-container .detail-totals-line .detail-total-item {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 150px;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(102, 126, 234, 0.16);
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.08);
}
.order-details-container .product-container .detail-totals-line .detail-total-item .detail-total-label,
.order-details-container .status-container .detail-totals-line .detail-total-item .detail-total-label,
.order-details-container .shipment-container .detail-totals-line .detail-total-item .detail-total-label,
.order-details-container .stock-container .detail-totals-line .detail-total-item .detail-total-label {
  color: var(--cui-secondary-color, #6c757d);
  font-weight: 600;
}
.order-details-container .product-container .detail-totals-line .detail-total-item strong,
.order-details-container .status-container .detail-totals-line .detail-total-item strong,
.order-details-container .shipment-container .detail-totals-line .detail-total-item strong,
.order-details-container .stock-container .detail-totals-line .detail-total-item strong {
  color: #4f5bd5;
  font-size: 1rem;
}
.order-details-container .product-container .detail-totals-line .detail-total-roll,
.order-details-container .status-container .detail-totals-line .detail-total-roll,
.order-details-container .shipment-container .detail-totals-line .detail-total-roll,
.order-details-container .stock-container .detail-totals-line .detail-total-roll {
  border-color: rgba(118, 75, 162, 0.22);
}
.order-details-container .product-container .detail-totals-line .detail-total-roll strong,
.order-details-container .status-container .detail-totals-line .detail-total-roll strong,
.order-details-container .shipment-container .detail-totals-line .detail-total-roll strong,
.order-details-container .stock-container .detail-totals-line .detail-total-roll strong {
  color: #764ba2;
}
html[data-coreui-theme=dark] .order-details-container .product-container .detail-totals-line,
html[data-coreui-theme=dark] .order-details-container .status-container .detail-totals-line,
html[data-coreui-theme=dark] .order-details-container .shipment-container .detail-totals-line,
html[data-coreui-theme=dark] .order-details-container .stock-container .detail-totals-line {
  background: rgba(102, 126, 234, 0.15);
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .order-details-container .product-container .detail-totals-line .detail-total-item,
html[data-coreui-theme=dark] .order-details-container .status-container .detail-totals-line .detail-total-item,
html[data-coreui-theme=dark] .order-details-container .shipment-container .detail-totals-line .detail-total-item,
html[data-coreui-theme=dark] .order-details-container .stock-container .detail-totals-line .detail-total-item {
  background: rgba(33, 38, 49, 0.7);
}
.order-details-container .shipment-table,
.order-details-container .stock-table {
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.order-details-container .shipment-table thead th,
.order-details-container .stock-table thead th {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border: none;
  padding: 1rem 1.5rem;
  font-weight: 700;
  color: var(--cui-primary, #667eea);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.875rem;
  position: relative;
}
.order-details-container .shipment-table thead th::after,
.order-details-container .stock-table thead th::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--cui-primary, #667eea);
  opacity: 0.3;
}
html[data-coreui-theme=dark] .order-details-container .shipment-table thead th,
html[data-coreui-theme=dark] .order-details-container .stock-table thead th {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
  color: var(--cui-primary, #667eea);
}
.order-details-container .shipment-table tbody tr,
.order-details-container .stock-table tbody tr {
  transition: all 0.2s ease;
}
.order-details-container .shipment-table tbody tr:hover,
.order-details-container .stock-table tbody tr:hover {
  background: rgba(102, 126, 234, 0.02);
  transform: scale(1.01);
}
.order-details-container .shipment-table tbody tr td,
.order-details-container .stock-table tbody tr td {
  padding: 1rem 1.5rem;
  border: none;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
  vertical-align: middle;
  color: var(--cui-body-color, #2c3e50);
  font-weight: 500;
}
html[data-coreui-theme=dark] .order-details-container .shipment-table tbody tr td,
html[data-coreui-theme=dark] .order-details-container .stock-table tbody tr td {
  color: var(--cui-body-color, #fff);
  border-bottom-color: rgba(102, 126, 234, 0.2);
}
.order-details-container .shipment-table tbody tr td .badge,
.order-details-container .stock-table tbody tr td .badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}
.order-details-container .shipment-table tbody tr td .badge:hover,
.order-details-container .stock-table tbody tr td .badge:hover {
  transform: scale(1.05);
}
.order-details-container .shipment-table tbody tr td .icon,
.order-details-container .stock-table tbody tr td .icon {
  color: var(--cui-secondary-color, #6c757d);
  margin-right: 0.5rem;
}
html[data-coreui-theme=dark] .order-details-container .shipment-table tbody tr td .icon,
html[data-coreui-theme=dark] .order-details-container .stock-table tbody tr td .icon {
  color: var(--cui-secondary-color, #8a93a2);
}
.order-details-container .shipment-table tbody tr:last-child td,
.order-details-container .stock-table tbody tr:last-child td {
  border-bottom: none;
}
.order-details-container .status-badge {
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}
.order-details-container .status-badge:hover {
  transform: scale(1.05);
}
.order-details-container .swap-modal .modal-dialog {
  max-width: min(820px, 94vw);
  margin: 0.75rem auto;
}
.order-details-container .swap-modal .modal-content {
  border: none;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
  background: #ffffff;
  min-height: 560px;
}
html[data-coreui-theme=dark] .order-details-container .swap-modal .modal-content {
  background: var(--cui-dark-bg, #212631);
  border: 1px solid var(--cui-dark-border-subtle, #333);
}
.order-details-container .swap-modal .modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: none;
  padding: 1rem 1.5rem;
}
.order-details-container .swap-modal .modal-header .modal-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.order-details-container .swap-modal .modal-header .btn-close {
  filter: brightness(0) invert(1);
}
.order-details-container .swap-modal .modal-body {
  padding: 1.5rem;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.95) 100%);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
html[data-coreui-theme=dark] .order-details-container .swap-modal .modal-body {
  background: linear-gradient(135deg, rgba(33, 38, 49, 0.95) 0%, rgba(44, 48, 52, 0.95) 100%);
}
.order-details-container .swap-modal .swap-modal-summary {
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid rgba(102, 126, 234, 0.2);
  background: rgba(102, 126, 234, 0.08);
}
.order-details-container .swap-modal .swap-modal-summary .swap-modal-summary-title {
  color: var(--cui-primary, #667eea);
  font-weight: 700;
  font-size: 0.8rem;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.order-details-container .swap-modal .swap-modal-summary .swap-modal-summary-text {
  color: var(--cui-body-color, #2c3e50);
  font-weight: 600;
  font-size: 0.9rem;
}
html[data-coreui-theme=dark] .order-details-container .swap-modal .swap-modal-summary .swap-modal-summary-text {
  color: var(--cui-body-color, #fff);
}
.order-details-container .swap-modal .swap-modal-summary .swap-modal-readonly-field {
  background-color: var(--cui-tertiary-bg, #dee2e6) !important;
  border: 1px solid var(--cui-border-color, #cfd4da) !important;
  color: var(--cui-body-color, #2c3e50) !important;
  font-weight: 600;
  pointer-events: none;
  cursor: not-allowed;
  opacity: 1;
}
.order-details-container .swap-modal .swap-modal-summary .swap-modal-readonly-field:focus {
  box-shadow: none;
  border-color: var(--cui-border-color, #cfd4da);
}
.order-details-container .swap-modal .swap-modal-summary .swap-modal-readonly-field:disabled {
  background-color: var(--cui-tertiary-bg, #dee2e6) !important;
  border-color: var(--cui-border-color, #cfd4da) !important;
  color: var(--cui-body-color, #2c3e50) !important;
  -webkit-text-fill-color: var(--cui-body-color, #2c3e50);
  opacity: 1;
}
html[data-coreui-theme=dark] .order-details-container .swap-modal .swap-modal-summary .swap-modal-readonly-field {
  background-color: var(--cui-dark-bg-subtle, #3a4049) !important;
  border-color: var(--cui-dark-border-subtle, #5a6270) !important;
  color: var(--cui-body-color, #fff) !important;
}
html[data-coreui-theme=dark] .order-details-container .swap-modal .swap-modal-summary .swap-modal-readonly-field:disabled {
  background-color: var(--cui-dark-bg-subtle, #3a4049) !important;
  border-color: var(--cui-dark-border-subtle, #5a6270) !important;
  color: var(--cui-body-color, #fff) !important;
  -webkit-text-fill-color: var(--cui-body-color, #fff);
}
.order-details-container .swap-modal .swap-modal-summary-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}
.order-details-container .swap-modal .swap-modal-hint {
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  border: 1px solid rgba(13, 110, 253, 0.25);
  background: rgba(13, 110, 253, 0.08);
  color: var(--cui-body-color, #2c3e50);
}
html[data-coreui-theme=dark] .order-details-container .swap-modal .swap-modal-hint {
  color: var(--cui-body-color, #fff);
}
.order-details-container .swap-modal .swap-modal-help {
  font-size: 0.8rem;
  color: var(--cui-secondary-color, #6c757d);
}
html[data-coreui-theme=dark] .order-details-container .swap-modal .swap-modal-help {
  color: var(--cui-secondary-color, #8a93a2);
}
.order-details-container .swap-modal .form-label {
  font-weight: 600;
  color: var(--cui-body-color, #2c3e50);
  margin-bottom: 0.5rem;
}
html[data-coreui-theme=dark] .order-details-container .swap-modal .form-label {
  color: var(--cui-body-color, #fff);
}
.order-details-container .swap-modal .form-control,
.order-details-container .swap-modal .form-select {
  border-radius: 0.5rem;
  border: 1px solid rgba(102, 126, 234, 0.25);
  padding: 0.65rem 0.8rem;
}
.order-details-container .swap-modal .form-control:focus,
.order-details-container .swap-modal .form-select:focus {
  border-color: rgba(102, 126, 234, 0.7);
  box-shadow: 0 0 0 0.15rem rgba(102, 126, 234, 0.2);
}
.order-details-container .swap-modal .swap-modal-footer {
  border-top: 1px solid rgba(102, 126, 234, 0.15);
  padding: 1rem 1.5rem;
  justify-content: flex-end;
  gap: 0.5rem;
}
.order-details-container .empty-state {
  text-align: center;
  padding: 3rem 1rem;
}
.order-details-container .empty-state .empty-icon {
  color: var(--cui-secondary-color, #6c757d);
  margin-bottom: 1.5rem;
  opacity: 0.6;
  animation: float 3s ease-in-out infinite;
}
.order-details-container .empty-state h5 {
  color: var(--cui-body-color, #2c3e50);
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1.25rem;
}
.order-details-container .empty-state p {
  color: var(--cui-secondary-color, #6c757d);
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
}
html[data-coreui-theme=dark] .order-details-container .empty-state .empty-icon {
  color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .order-details-container .empty-state h5 {
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .order-details-container .empty-state p {
  color: var(--cui-secondary-color, #8a93a2);
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.order-details-container .order-summary-card,
.order-details-container .order-details-tabs {
  animation: slideInUp 0.6s ease-out;
}
@media (max-width: 1200px) {
  .order-details-container .order-summary-card .card-body .order-info-section .order-basic-info {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
  .order-details-container .shipment-table thead th,
  .order-details-container .shipment-table tbody td,
  .order-details-container .stock-table thead th,
  .order-details-container .stock-table tbody td {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
}
@media (max-width: 768px) {
  .order-details-container {
    padding: 1rem;
  }
  .order-details-container .order-details-header .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .order-details-container .order-details-header .header-left .header-title h3 {
    font-size: 1.5rem;
  }
  .order-details-container .order-summary-card .card-body {
    padding: 1rem;
  }
  .order-details-container .order-summary-card .order-info-section .order-header {
    flex-direction: column;
    gap: 1rem;
  }
  .order-details-container .order-summary-card .order-info-section .order-header .order-status-section {
    align-self: flex-start;
  }
  .order-details-container .order-summary-card .order-info-section .order-basic-info {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  .order-details-container .order-summary-card .order-summary-section {
    padding: 1rem;
  }
  .order-details-container .order-details-tabs .tabs-header .custom-tabs .custom-tab-link {
    padding: 1rem 1rem;
    font-size: 0.75rem;
  }
  .order-details-container .order-details-tabs .tabs-content {
    padding: 1rem;
  }
  .order-details-container .order-details-tabs .tabs-content .info-card .info-card-header {
    padding: 1rem;
  }
  .order-details-container .order-details-tabs .tabs-content .info-card .card-body {
    padding: 1rem;
  }
  .order-details-container .order-details-tabs .tabs-content .info-card .info-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .order-details-container .order-details-tabs .tabs-content .shipment-table,
  .order-details-container .order-details-tabs .tabs-content .stock-table {
    font-size: 0.875rem;
  }
  .order-details-container .order-details-tabs .tabs-content .shipment-table thead th,
  .order-details-container .order-details-tabs .tabs-content .shipment-table tbody td,
  .order-details-container .order-details-tabs .tabs-content .stock-table thead th,
  .order-details-container .order-details-tabs .tabs-content .stock-table tbody td {
    padding: 0.5rem;
    font-size: 0.8rem;
  }
}
@media (max-width: 480px) {
  .order-details-container {
    padding: 0.5rem;
  }
  .order-details-container .order-details-header .header-left .header-title h3 {
    font-size: 1.25rem;
  }
  .order-details-container .order-summary-card .card-body {
    padding: 0.5rem;
  }
  .order-details-container .order-details-tabs .tabs-content {
    padding: 0.5rem;
  }
  .order-details-container .order-details-tabs .tabs-content .shipment-table,
  .order-details-container .order-details-tabs .tabs-content .stock-table {
    font-size: 0.75rem;
  }
  .order-details-container .order-details-tabs .tabs-content .shipment-table thead th,
  .order-details-container .order-details-tabs .tabs-content .shipment-table tbody td,
  .order-details-container .order-details-tabs .tabs-content .stock-table thead th,
  .order-details-container .order-details-tabs .tabs-content .stock-table tbody td {
    padding: 0.25rem;
    font-size: 0.75rem;
  }
}
@media print {
  .order-details-container {
    background: white !important;
  }
  .order-details-container::before {
    display: none;
  }
  .order-details-container .order-details-header .header-left .back-button {
    display: none;
  }
  .order-details-container .order-summary-card,
  .order-details-container .order-details-tabs {
    box-shadow: none;
    border: 1px solid #ddd;
  }
  .order-details-container .tabs-header {
    background: #f8f9fa !important;
    color: #333 !important;
  }
  .order-details-container .shipment-table,
  .order-details-container .stock-table {
    box-shadow: none;
    border: 1px solid #ddd;
  }
}
@media (prefers-contrast: high) {
  .order-details-container .order-summary-card,
  .order-details-container .order-details-tabs {
    border: 2px solid #000;
  }
  .order-details-container .info-card {
    border: 1px solid #666;
  }
  .order-details-container .summary-item {
    border-bottom-color: #333;
  }
  .order-details-container .shipment-table,
  .order-details-container .stock-table {
    border: 1px solid #000;
  }
  .order-details-container .shipment-table thead th,
  .order-details-container .shipment-table tbody td,
  .order-details-container .stock-table thead th,
  .order-details-container .stock-table tbody td {
    border: 1px solid #666;
  }
}
@media (prefers-reduced-motion: reduce) {
  .order-details-container *,
  .order-details-container *::before,
  .order-details-container *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/OrderDetails/OrderDetails.scss"],"names":[],"mappings":"AA+DA;EACE,eAjDW;EAkDX,6DAAA;EACA,iBAAA;EACA,kBAAA;AA9DF;AAiEE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,8FAAA;EACA,WAAA;AA/DJ;AAmEE;EACE,6DAAA;EACA,kCAAA;AAjEJ;AAmEI;EACE,gGAAA;AAjEN;AAuEE;EA3CA,aAAA;EACA,mBAAA;EACA,uBAAA;EA2CE,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SApFS;AAiBb;AAqEI;EACE,aAAA;EACA,cAAA;EACA,4BAAA;AAnEN;AAsEI;EACE,gBAAA;EACA,qBAAA;AApEN;AA0EE;;EAEE,aApGS;AA4Bb;AA0EI;;;;EAEE,qBAnHe;EAoHf,YAAA;EACA,wCAnHM;EAkCV,yBA9BkB;AA0CpB;AAVE;;;;EACE,2BAAA;EACA,0CApCQ;AAmDZ;AAiEM;;;;EA3EJ,aAAA;EACA,mBAAA;EACA,uBAAA;EA2EM,WAlHK;EAmHL,gBAAA;AA1DR;AAiEE;EACE,mBAxHS;AAyDb;AAiEI;EACE,aAAA;EACA,mBAAA;EACA,SA/HO;AAgEb;AAiEM;EACE,qBA3Ia;EA4Ib,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBA1IU;EA2IV,kBAAA;EACA,gBAAA;AA/DR;AAiEQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,qBAAA;AA/DV;AAkEQ;EACE,2BAAA;AAhEV;AAkEU;EACE,UAAA;AAhEZ;AAsEQ;EACE,SAAA;EACA,gBAAA;EACA,qCAAA;EACA,mCAAA;EACA,sBAAA;AApEV;AAuEQ;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBA7KG;EA8KH,YAAA;AArEV;AA6EE;EACE,mBAnLS;EAoLT,YAAA;EACA,sBA/LkB;EAgMlB,0CA9LQ;EA+LR,gBAAA;EACA,kBAAA;EA/JF,yBA9BkB;AAmHpB;AAnFE;EACE,2BAAA;EACA,0CApCQ;AAyHZ;AA0EI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EArLJ,6DAAA;AA8GF;AA2EI;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AAzEN;AA4EI;EACE,aA7MO;EA8MP,+FAAA;AA1EN;AA4EM;EACE,yFAAA;AA1ER;AAgFM;EA/KJ,aAAA;EACA,mBAAA;EACA,8BAAA;EA+KM,qBA1NK;EA2NL,oBA5NK;EA6NL,iDAAA;AA5ER;AA+EU;EACE,oBAAA;EACA,gBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;AA7EZ;AA+EY;EACE,oBA3OD;EA4OC,kCAAA;AA7Ed;AAgFY;EACE,kCAAA;AA9Ed;AAkFU;EACE,SAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAhFZ;AAkFY;EACE,0CAAA;AAhFd;AAsFU;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,wCA7QA;EA8QA,yBA3QM;AAuLlB;AAsFY;EACE,sBAAA;AApFd;AA0FM;EACE,aAAA;EACA,2DAAA;EACA,SAnRK;AA2Lb;AA0FQ;EACE,aAAA;EACA,mBAAA;EACA,WAzRG;EA0RH,eA1RG;EA2RH,qBAnSW;EAoSX,yBA/RQ;EAgSR,oCAAA;AAxFV;AA0FU;EACE,qCAAA;EACA,0BAAA;AAxFZ;AA2FU;EACE,iCAAA;AAzFZ;AA2FY;EACE,oCAAA;AAzFd;AA6FU;EACE,kCAAA;EACA,iBAAA;EACA,eAAA;AA3FZ;AA8FU;EACE,qCAAA;EACA,mBAAA;EACA,gBAAA;AA5FZ;AA8FY;EACE,gBAAA;EACA,kCAAA;AA5Fd;AA+FY;EACE,kCAAA;AA7Fd;AAqGI;EACE,gGAAA;EACA,qBA/Ue;EAgVf,eAtUO;AAmOb;AAqGM;EA/RJ,aAAA;EACA,mBAAA;EACA,8BAAA;EA+RM,eAAA;EACA,iDAAA;EACA,yBAjVU;AAgPlB;AAmGQ;EACE,oBAjVG;EAkVH,qCAAA;AAjGV;AAoGQ;EACE,mBAAA;AAlGV;AAqGQ;EACE,6CAAA;AAnGV;AAsGQ;EACE,iDAAA;EACA,mBAAA;EACA,mBA9VG;EA+VH,eA/VG;EAgWH,kBAlWG;EAmWH,8FAAA;EACA,qBA5WW;AAwQrB;AAsGU;;EAEE,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,yCAAA;AApGZ;AAwGQ;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAtGV;AAwGU;EACE,0CAAA;AAtGZ;AA0GQ;EACE,qCAAA;EACA,gBAAA;EACA,eAAA;AAxGV;AA0GU;EACE,kCAAA;AAxGZ;AAiHE;EACE,YAAA;EACA,sBAnZkB;EAoZlB,0CAlZQ;EAmZR,gBAAA;EAlXF,yBA9BkB;AAkSpB;AAlQE;EACE,2BAAA;EACA,0CApCQ;AAwSZ;AA6GI;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AA3GN;AA8GI;EAvYF,6DAAA;EAyYI,mBAAA;EACA,UAAA;EACA,kBAAA;AA5GN;AA8GM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oCAAA;AA5GR;AA+GM;EACE,YAAA;AA7GR;AA+GQ;EACE,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAnbU;EAobV,kBAAA;EACA,yBAAA;EACA,mBAAA;AA7GV;AA+GU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,oBAAA;EACA,+BAAA;EACA,sBAAA;AA7GZ;AAgHU;EACE,YAAA;AA9GZ;AAgHY;EACE,oBAAA;AA9Gd;AAkHU;EACE,YAAA;EACA,2CAAA;EACA,8BAAA;AAhHZ;AAkHY;EACE,oBAAA;AAhHd;AAoHU;EACE,kBAAA;EACA,uBAAA;EACA,mBAxdC;EAydD,oCAAA;EACA,0CAAA;AAlHZ;AAwHI;EACE,aA9dO;EA+dP,+FAAA;AAtHN;AAwHM;EACE,yFAAA;AAtHR;AA0HM;EACE,YAAA;EACA,qBAnfa;EAofb,wCAlfI;EAmfJ,qBA3eK;EA4eL,gBAAA;EAldN,yBA9BkB;AAyXpB;AAzVE;EACE,2BAAA;EACA,0CApCQ;AA+XZ;AAsHQ;EACE,uCAAA;EACA,iDAAA;EACA,wCAAA;AApHV;AAuHQ;EA/dN,6DAAA;EAieQ,mBAAA;EACA,oBAAA;EACA,kBAAA;AArHV;AAuHU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oCAAA;AArHZ;AAwHU;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AAtHZ;AAwHY;EACE,oBAlhBD;AA4Zb;AA2HQ;EACE,aArhBG;EAshBH,oCAAA;AAzHV;AA2HU;EACE,iCAAA;AAzHZ;AA6HQ;EACE,aAAA;EACA,2DAAA;EACA,WAjiBG;AAsab;AA6HU;EACE,kBAAA;EACA,aAtiBC;EAuiBD,qBAhjBS;EAijBT,oCAAA;EACA,yBA7iBM;AAkblB;AA6HY;EACE,qCAAA;EACA,2BAAA;AA3Hd;AA8HY;EACE,iCAAA;AA5Hd;AA8Hc;EACE,oCAAA;AA5HhB;AAgIY;EACE,cAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAhkBD;EAikBC,kBAAA;AA9Hd;AAgIc;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,uCAAA;AA9HhB;AAkIY;EACE,qCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAhId;AAkIc;EACE,gBAAA;EACA,kCAAA;EACA,iBAAA;AAhIhB;AAmIc;EACE,kCAAA;AAjIhB;AAqIY;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wCA5mBF;AAyeZ;AAiJI;;;;;;;;;;;;;;;;EAIE,mBArnBO;EAsnBP,oBAxnBO;EAynBP,iDAAA;AAnIN;AAqIM;;;;;;;;;;;;;;;;EACE,oBAAA;EACA,gBAAA;EACA,qCAAA;EACA,iBAAA;EACA,sBAAA;AApHR;AAsHQ;;;;;;;;;;;;;;;;EACE,kCAAA;AArGV;AAyGM;;;;;;;;;;;;;;;;EACE,SAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;AAxFR;AA0FQ;;;;;;;;;;;;;;;;EACE,0CAAA;AAzEV;AA8EI;;;;EACE,gBAAA;AAzEN;AA4EI;;;;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SA3pBO;EA4pBP,gBA5pBO;EA6pBP,aA7pBO;EA8pBP,0CAAA;EACA,qBAxqBe;EAyqBf,gGAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAvEN;AAyEM;;;;EACE,oBAAA;EACA,mBAAA;EACA,YA3qBK;EA4qBL,gBAAA;EACA,oBAAA;EACA,2CAAA;EACA,qBAtrBa;EAurBb,qCAAA;EACA,+CAAA;AApER;AAsEQ;;;;EACE,0CAAA;EACA,gBAAA;AAjEV;AAoEQ;;;;EACE,cAAA;EACA,eAAA;AA/DV;AAmEM;;;;EACE,sCAAA;AA9DR;AAgEQ;;;;EACE,cAAA;AA3DV;AA+DM;;;;EACE,qCAAA;EACA,kCAAA;AA1DR;AA4DQ;;;;EACE,iCAAA;AAvDV;AA+DE;;EAEE,qBA5tBiB;EA6tBjB,gBAAA;EACA,wCA5tBQ;AA+pBZ;AAgEM;;EACE,8FAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AA7DR;AA+DQ;;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,uCAAA;EACA,YAAA;AA5DV;AA+DQ;;EACE,gGAAA;EACA,kCAAA;AA5DV;AAkEM;;EACE,yBA3vBU;AA4rBlB;AAiEQ;;EACE,qCAAA;EACA,sBAAA;AA9DV;AAiEQ;;EACE,oBAAA;EACA,YAAA;EACA,iDAAA;EACA,sBAAA;EACA,qCAAA;EACA,gBAAA;AA9DV;AAgEU;;EACE,kCAAA;EACA,6CAAA;AA7DZ;AAgEU;;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wCAvxBA;EAwxBA,yBArxBM;AAwtBlB;AA+DY;;EACE,sBAAA;AA5Dd;AAgEU;;EACE,0CAAA;EACA,oBA3xBC;AA8tBb;AA+DY;;EACE,0CAAA;AA5Dd;AAiEQ;;EACE,mBAAA;AA9DV;AAsEE;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wCAvzBQ;EAwzBR,yBArzBc;AAivBlB;AAsEI;EACE,sBAAA;AApEN;AAyEI;EACE,2BAAA;EACA,oBAAA;AAvEN;AA0EI;EACE,YAAA;EACA,sBAx0BgB;EAy0BhB,gBAAA;EACA,0CAv0BM;EAw0BN,mBAAA;EACA,iBAAA;AAxEN;AA0EM;EACE,uCAAA;EACA,qDAAA;AAxER;AA4EI;EA7zBF,6DAAA;EA+zBI,mBAAA;EACA,oBAAA;AA1EN;AA4EM;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;AA1ER;AA6EM;EACE,+BAAA;AA3ER;AA+EI;EACE,eA51BO;EA61BP,iGAAA;EACA,aAAA;EACA,sBAAA;EACA,WAl2BO;AAqxBb;AA+EM;EACE,2FAAA;AA7ER;AAiFI;EACE,aAz2BO;EA02BP,qBAn3Be;EAo3Bf,0CAAA;EACA,qCAAA;AA/EN;AAiFM;EACE,kCAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAp3BK;EAq3BL,yBAAA;EACA,qBAAA;AA/ER;AAkFM;EACE,qCAAA;EACA,gBAAA;EACA,iBAAA;AAhFR;AAkFQ;EACE,kCAAA;AAhFV;AAoFM;EACE,4DAAA;EACA,6DAAA;EACA,gDAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;AAlFR;AAoFQ;EACE,gBAAA;EACA,8CAAA;AAlFV;AAqFQ;EACE,4DAAA;EACA,yDAAA;EACA,gDAAA;EACA,uDAAA;EACA,UAAA;AAnFV;AAsFQ;EACE,+DAAA;EACA,+DAAA;EACA,6CAAA;AApFV;AAsFU;EACE,+DAAA;EACA,+DAAA;EACA,6CAAA;EACA,oDAAA;AApFZ;AA0FI;EACE,aAAA;EACA,0BAAA;EACA,WA16BO;AAk1Bb;AA2FI;EACE,qBA96BO;EA+6BP,qBAv7Be;EAw7Bf,kBAAA;EACA,0CAAA;EACA,oCAAA;EACA,qCAAA;AAzFN;AA2FM;EACE,kCAAA;AAzFR;AA6FI;EACE,iBAAA;EACA,0CAAA;AA3FN;AA6FM;EACE,0CAAA;AA3FR;AA+FI;EACE,gBAAA;EACA,qCAAA;EACA,qBAt8BO;AAy2Bb;AA+FM;EACE,kCAAA;AA7FR;AAiGI;;EAEE,qBAv9Be;EAw9Bf,2CAAA;EACA,uBAAA;AA/FN;AAiGM;;EACE,sCAAA;EACA,kDAAA;AA9FR;AAkGI;EACE,+CAAA;EACA,oBAAA;EACA,yBAAA;EACA,WA79BO;AA63Bb;AAsGE;EACE,kBAAA;EACA,kBAAA;AApGJ;AAsGI;EACE,0CAAA;EACA,qBAv+BO;EAw+BP,YAAA;EACA,wCAAA;AApGN;AAuGI;EACE,qCAAA;EACA,qBAh/BO;EAi/BP,gBAAA;EACA,kBAAA;AArGN;AAwGI;EACE,0CAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAtGN;AA0GM;EACE,0CAAA;AAxGR;AA2GM;EACE,kCAAA;AAzGR;AA4GM;EACE,0CAAA;AA1GR;AAiHE;EACE;IAAW,UAAA;EA9Gb;EA+GE;IAAM,YAAA;EA5GR;AACF;AA8GE;EACE;IAAW,0BAAA;EA3Gb;EA4GE;IAAM,4BAAA;EAzGR;AACF;AA2GE;EACE;IACE,UAAA;IACA,2BAAA;EAzGJ;EA2GE;IACE,UAAA;IACA,wBAAA;EAzGJ;AACF;AA6GE;;EAEE,kCAAA;AA3GJ;AAgHE;EACE;IACE,2DAAA;EA9GJ;EAmHI;;;;IAEE,oBAAA;IACA,mBAAA;EA/GN;AACF;AAmHE;EAvgCF;IAwgCI,aAzjCS;EAy8BX;EAmHI;IACE,sBAAA;IACA,uBAAA;IACA,WAhkCK;EA+8BX;EAmHM;IACE,iBAAA;EAjHR;EAuHI;IACE,aAzkCK;EAo9BX;EAyHM;IACE,sBAAA;IACA,SA/kCG;EAw9BX;EAyHQ;IACE,sBAAA;EAvHV;EA2HM;IACE,0BAAA;IACA,WAzlCG;EAg+BX;EA6HI;IACE,aA7lCK;EAk+BX;EAkIQ;IACE,kBAAA;IACA,kBAAA;EAhIV;EAqII;IACE,aA5mCK;EAy+BX;EAsIQ;IACE,aAhnCC;EA4+BX;EAuIQ;IACE,aApnCC;EA++BX;EAwIQ;IACE,0BAAA;IACA,SAznCC;EAm/BX;EA0IM;;IAEE,mBAAA;EAxIR;EA0IQ;;;;IAEE,eApoCC;IAqoCD,iBAAA;EAtIV;AACF;AA4IE;EA1lCF;IA2lCI,eA7oCS;EAogCX;EA2IE;IACE,kBAAA;EAzIJ;EA4IE;IACE,eAppCO;EA0gCX;EA6IE;IACE,eAxpCO;EA6gCX;EA6II;;IAEE,kBAAA;EA3IN;EA6IM;;;;IAEE,gBAjqCG;IAkqCH,kBAAA;EAzIR;AACF;AAgJE;EAvnCF;IAwnCI,4BAAA;EA7IF;EA+IE;IACE,aAAA;EA7IJ;EAgJE;IACE,aAAA;EA9IJ;EAiJE;;IAEE,gBAAA;IACA,sBAAA;EA/IJ;EAkJE;IACE,8BAAA;IACA,sBAAA;EAhJJ;EAmJE;;IAEE,gBAAA;IACA,sBAAA;EAjJJ;AACF;AAsJE;EACE;;IAEE,sBAAA;EApJJ;EAuJE;IACE,sBAAA;EArJJ;EAwJE;IACE,yBAAA;EAtJJ;EAyJE;;IAEE,sBAAA;EAvJJ;EAyJI;;;;IAEE,sBAAA;EArJN;AACF;AA2JE;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;EAzJJ;AACF","sourcesContent":["// Order Details Component - Professional SCSS\n// =============================================\n\n// Variables\n// ---------\n$border-radius-base: 0.5rem;\n$border-radius-large: 0.75rem;\n$shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.1);\n$shadow-md: 0 4px 20px rgba(0, 0, 0, 0.08);\n$shadow-lg: 0 6px 25px rgba(0, 0, 0, 0.15);\n$transition-base: all 0.2s ease;\n$transition-smooth: all 0.3s ease;\n$spacing-xs: 0.25rem;\n$spacing-sm: 0.5rem;\n$spacing-md: 1rem;\n$spacing-lg: 1.5rem;\n$spacing-xl: 2rem;\n$spacing-xxl: 3rem;\n\n// Mixins\n// ------\n@mixin glass-effect {\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n@mixin gradient-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n@mixin gradient-secondary {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n}\n\n@mixin gradient-success {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n@mixin card-hover-effect {\n  transition: $transition-smooth;\n  \n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: $shadow-lg;\n  }\n}\n\n@mixin flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@mixin flex-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n// Main Container\n// --------------\n.order-details-container {\n  padding: $spacing-lg;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  min-height: 100vh;\n  position: relative;\n  \n  // Background pattern\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 200px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    z-index: -1;\n  }\n\n  // Dark mode support\n  html[data-coreui-theme=\"dark\"] & {\n    background: linear-gradient(135deg, #1a1d24 0%, #2c3034 100%);\n    color: var(--cui-body-color, #fff);\n    \n    &::before {\n      background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n    }\n  }\n\n  // Loading States\n  // --------------\n  .order-details-loading {\n    @include flex-center;\n    flex-direction: column;\n    min-height: 400px;\n    text-align: center;\n    gap: $spacing-md;\n\n    .order-details-spinner {\n      width: 2.5rem;\n      height: 2.5rem;\n      animation: pulse 2s infinite;\n    }\n\n    p {\n      font-weight: 500;\n      letter-spacing: 0.5px;\n    }\n  }\n\n  // Error & Warning States\n  // ----------------------\n  .order-details-error,\n  .order-details-not-found {\n    padding: $spacing-xl;\n    \n    .error-alert,\n    .warning-alert {\n      border-radius: $border-radius-base;\n      border: none;\n      box-shadow: $shadow-sm;\n      @include card-hover-effect;\n\n      .alert-content {\n        @include flex-center;\n        gap: $spacing-sm;\n        font-weight: 500;\n      }\n    }\n  }\n\n  // Header Section\n  // --------------\n  .order-details-header {\n    margin-bottom: $spacing-xl;\n    \n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: $spacing-md;\n      \n      .back-button {\n        border-radius: $border-radius-base;\n        padding: $spacing-sm $spacing-md;\n        font-weight: 600;\n        letter-spacing: 0.5px;\n        transition: $transition-base;\n        position: relative;\n        overflow: hidden;\n        \n        &::before {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: -100%;\n          width: 100%;\n          height: 100%;\n          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n          transition: left 0.5s;\n        }\n        \n        &:hover {\n          transform: translateX(-3px);\n          \n          &::before {\n            left: 100%;\n          }\n        }\n      }\n      \n      .header-title {\n        h3 {\n          margin: 0;\n          font-weight: 700;\n          color: var(--cui-body-color, #2c3e50);\n          font-size: clamp(1.5rem, 4vw, 2rem);\n          letter-spacing: -0.5px;\n        }\n        \n        .header-subtitle {\n          color: var(--cui-secondary-color, #6c757d);\n          font-size: 0.875rem;\n          font-weight: 500;\n          margin-top: $spacing-xs;\n          opacity: 0.8;\n        }\n      }\n    }\n  }\n\n  // Order Summary Card\n  // ------------------\n  .order-summary-card {\n    margin-bottom: $spacing-xl;\n    border: none;\n    border-radius: $border-radius-large;\n    box-shadow: $shadow-md;\n    overflow: hidden;\n    position: relative;\n    @include card-hover-effect;\n    \n    // Gradient border effect\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 4px;\n      @include gradient-primary;\n    }\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n    }\n    \n    .card-body {\n      padding: $spacing-xl;\n      background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 249, 250, 0.9) 100%);\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: linear-gradient(135deg, rgba(33, 38, 49, 0.9) 0%, rgba(44, 48, 52, 0.9) 100%);\n      }\n    }\n    \n    // Order Info Section\n    .order-info-section {\n      .order-header {\n        @include flex-between;\n        margin-bottom: $spacing-lg;\n        padding-bottom: $spacing-md;\n        border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n        \n        .order-title-section {\n          .order-title {\n            margin: 0 0 $spacing-sm 0;\n            font-weight: 700;\n            color: var(--cui-body-color, #2c3e50);\n            display: flex;\n            align-items: center;\n            font-size: 1.5rem;\n            letter-spacing: -0.5px;\n            \n            .icon {\n              margin-right: $spacing-sm;\n              color: var(--cui-primary, #667eea);\n            }\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-body-color, #fff);\n            }\n          }\n          \n          .order-id {\n            margin: 0;\n            color: var(--cui-secondary-color, #6c757d);\n            font-size: 0.875rem;\n            font-weight: 500;\n            font-family: 'Monaco', 'Menlo', monospace;\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-secondary-color, #8a93a2);\n            }\n          }\n        }\n        \n        .order-status-section {\n          .order-status-badge {\n            font-weight: 600;\n            padding: $spacing-sm $spacing-md;\n            font-size: 0.875rem;\n            letter-spacing: 0.5px;\n            box-shadow: $shadow-sm;\n            transition: $transition-base;\n            \n            &:hover {\n              transform: scale(1.05);\n            }\n          }\n        }\n      }\n      \n      .order-basic-info {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n        gap: $spacing-md;\n        \n        .info-item {\n          display: flex;\n          align-items: center;\n          gap: $spacing-sm;\n          padding: $spacing-sm;\n          border-radius: $border-radius-base;\n          transition: $transition-base;\n          background: rgba(255, 255, 255, 0.5);\n          \n          &:hover {\n            background: rgba(102, 126, 234, 0.05);\n            transform: translateX(2px);\n          }\n          \n          html[data-coreui-theme=\"dark\"] & {\n            background: rgba(33, 38, 49, 0.5);\n            \n            &:hover {\n              background: rgba(102, 126, 234, 0.1);\n            }\n          }\n          \n          .info-icon {\n            color: var(--cui-primary, #667eea);\n            font-size: 1.1rem;\n            min-width: 20px;\n          }\n          \n          .info-text {\n            color: var(--cui-body-color, #2c3e50);\n            font-size: 0.875rem;\n            line-height: 1.5;\n            \n            strong {\n              font-weight: 600;\n              color: var(--cui-primary, #667eea);\n            }\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-body-color, #fff);\n            }\n          }\n        }\n      }\n    }\n    \n    // Summary Section\n    .order-summary-section {\n      background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n      border-radius: $border-radius-base;\n      padding: $spacing-lg;\n      \n      .summary-item {\n        @include flex-between;\n        padding: $spacing-md 0;\n        border-bottom: 1px solid rgba(102, 126, 234, 0.1);\n        transition: $transition-base;\n        \n        &:hover {\n          padding-left: $spacing-sm;\n          background: rgba(102, 126, 234, 0.02);\n        }\n        \n        &:last-child {\n          border-bottom: none;\n        }\n        \n        html[data-coreui-theme=\"dark\"] & {\n          border-bottom-color: rgba(102, 126, 234, 0.2);\n        }\n        \n        &.total {\n          border-top: 2px solid var(--cui-primary, #667eea);\n          border-bottom: none;\n          padding-top: $spacing-lg;\n          padding: $spacing-lg;\n          margin-top: $spacing-sm;\n          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n          border-radius: $border-radius-base;\n          \n          .summary-label,\n          .summary-value {\n            font-weight: 700;\n            font-size: 1.2rem;\n            color: var(--cui-primary, #667eea);\n            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n          }\n        }\n        \n        .summary-label {\n          color: var(--cui-secondary-color, #6c757d);\n          font-size: 0.875rem;\n          font-weight: 600;\n          letter-spacing: 0.5px;\n          text-transform: uppercase;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            color: var(--cui-secondary-color, #8a93a2);\n          }\n        }\n        \n        .summary-value {\n          color: var(--cui-body-color, #2c3e50);\n          font-weight: 700;\n          font-size: 1rem;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            color: var(--cui-body-color, #fff);\n          }\n        }\n      }\n    }\n  }\n\n  // Tabs Section\n  // ------------\n  .order-details-tabs {\n    border: none;\n    border-radius: $border-radius-large;\n    box-shadow: $shadow-md;\n    overflow: hidden;\n    @include card-hover-effect;\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n    }\n    \n    .tabs-header {\n      @include gradient-primary;\n      border-bottom: none;\n      padding: 0;\n      position: relative;\n      \n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 1px;\n        background: rgba(255, 255, 255, 0.2);\n      }\n      \n      .custom-tabs {\n        border: none;\n        \n        .custom-tab-link {\n          color: rgba(255, 255, 255, 0.8);\n          border: none;\n          border-radius: 0;\n          padding: $spacing-lg $spacing-xl;\n          font-weight: 600;\n          letter-spacing: 0.5px;\n          transition: $transition-smooth;\n          position: relative;\n          text-transform: uppercase;\n          font-size: 0.875rem;\n          \n          &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: rgba(255, 255, 255, 0.1);\n            transform: scaleX(0);\n            transition: transform 0.3s ease;\n            transform-origin: left;\n          }\n          \n          &:hover {\n            color: white;\n            \n            &::before {\n              transform: scaleX(1);\n            }\n          }\n          \n          &.active {\n            color: white;\n            background-color: rgba(255, 255, 255, 0.15);\n            border-bottom: 3px solid white;\n            \n            &::before {\n              transform: scaleX(1);\n            }\n          }\n          \n          .badge {\n            font-size: 0.75rem;\n            padding: $spacing-xs $spacing-sm;\n            margin-left: $spacing-sm;\n            background: rgba(255, 255, 255, 0.2);\n            border: 1px solid rgba(255, 255, 255, 0.3);\n          }\n        }\n      }\n    }\n    \n    .tabs-content {\n      padding: $spacing-xl;\n      background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 249, 250, 0.9) 100%);\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: linear-gradient(135deg, rgba(33, 38, 49, 0.9) 0%, rgba(44, 48, 52, 0.9) 100%);\n      }\n      \n      // Info Cards\n      .info-card {\n        border: none;\n        border-radius: $border-radius-base;\n        box-shadow: $shadow-sm;\n        margin-bottom: $spacing-lg;\n        overflow: hidden;\n        @include card-hover-effect;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          background: var(--cui-dark-bg, #212631);\n          border-color: var(--cui-dark-border-subtle, #333);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n        }\n        \n        .info-card-header {\n          @include gradient-success;\n          border-bottom: none;\n          padding: $spacing-lg $spacing-xl;\n          position: relative;\n          \n          &::after {\n            content: '';\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            height: 1px;\n            background: rgba(255, 255, 255, 0.2);\n          }\n          \n          h6 {\n            margin: 0;\n            font-weight: 700;\n            color: white;\n            display: flex;\n            align-items: center;\n            font-size: 1rem;\n            letter-spacing: 0.5px;\n            text-transform: uppercase;\n            \n            .icon {\n              margin-right: $spacing-sm;\n            }\n          }\n        }\n        \n        .card-body {\n          padding: $spacing-xl;\n          background: rgba(255, 255, 255, 0.8);\n          \n          html[data-coreui-theme=\"dark\"] & {\n            background: rgba(33, 38, 49, 0.8);\n          }\n        }\n        \n        .info-grid {\n          display: grid;\n          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n          gap: $spacing-lg;\n          \n          .info-item {\n            position: relative;\n            padding: $spacing-md;\n            border-radius: $border-radius-base;\n            background: rgba(255, 255, 255, 0.6);\n            transition: $transition-base;\n            \n            &:hover {\n              background: rgba(102, 126, 234, 0.05);\n              transform: translateY(-2px);\n            }\n            \n            html[data-coreui-theme=\"dark\"] & {\n              background: rgba(33, 38, 49, 0.6);\n              \n              &:hover {\n                background: rgba(102, 126, 234, 0.1);\n              }\n            }\n            \n            .info-label {\n              display: block;\n              font-weight: 700;\n              color: var(--cui-primary, #667eea);\n              font-size: 0.75rem;\n              text-transform: uppercase;\n              letter-spacing: 1px;\n              margin-bottom: $spacing-sm;\n              position: relative;\n              \n              &::after {\n                content: '';\n                position: absolute;\n                bottom: -2px;\n                left: 0;\n                width: 20px;\n                height: 2px;\n                background: var(--cui-primary, #667eea);\n              }\n            }\n            \n            .info-value {\n              color: var(--cui-body-color, #2c3e50);\n              font-weight: 600;\n              display: flex;\n              align-items: center;\n              font-size: 1rem;\n              line-height: 1.4;\n              \n              &.total-price {\n                font-weight: 700;\n                color: var(--cui-success, #2eb85c);\n                font-size: 1.2rem;\n              }\n              \n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-body-color, #fff);\n              }\n            }\n            \n            .system-badge {\n              font-size: 0.75rem;\n              padding: $spacing-xs $spacing-sm;\n              font-weight: 600;\n              letter-spacing: 0.5px;\n              box-shadow: $shadow-sm;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Content Containers\n  // ------------------\n  .product-container,\n  .status-container,\n  .shipment-container,\n  .stock-container {\n    .product-header,\n    .status-header,\n    .shipment-header,\n    .stock-header {\n      margin-bottom: $spacing-xl;\n      padding-bottom: $spacing-md;\n      border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n      \n      h5 {\n        margin: 0 0 $spacing-sm 0;\n        font-weight: 700;\n        color: var(--cui-body-color, #2c3e50);\n        font-size: 1.5rem;\n        letter-spacing: -0.5px;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-body-color, #fff);\n        }\n      }\n      \n      p {\n        margin: 0;\n        color: var(--cui-secondary-color, #6c757d);\n        font-size: 1rem;\n        font-weight: 500;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-secondary-color, #8a93a2);\n        }\n      }\n    }\n\n    > .info-card {\n      margin-bottom: 0;\n    }\n\n    .detail-totals-line {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      gap: $spacing-md;\n      margin-top: $spacing-md;\n      padding: $spacing-md;\n      border: 1px solid rgba(102, 126, 234, 0.2);\n      border-radius: $border-radius-base;\n      background: linear-gradient(135deg, rgba(102, 126, 234, 0.07) 0%, rgba(118, 75, 162, 0.07) 100%);\n      color: var(--cui-body-color, #2c3e50);\n      font-size: 0.95rem;\n      white-space: nowrap;\n      overflow-x: auto;\n\n      .detail-total-item {\n        display: inline-flex;\n        align-items: center;\n        gap: $spacing-xs;\n        min-width: 150px;\n        padding: $spacing-sm $spacing-md;\n        border: 1px solid rgba(102, 126, 234, 0.16);\n        border-radius: $border-radius-base;\n        background: rgba(255, 255, 255, 0.72);\n        box-shadow: 0 2px 6px rgba(102, 126, 234, 0.08);\n\n        .detail-total-label {\n          color: var(--cui-secondary-color, #6c757d);\n          font-weight: 600;\n        }\n\n        strong {\n          color: #4f5bd5;\n          font-size: 1rem;\n        }\n      }\n\n      .detail-total-roll {\n        border-color: rgba(118, 75, 162, 0.22);\n\n        strong {\n          color: #764ba2;\n        }\n      }\n\n      html[data-coreui-theme=\"dark\"] & {\n        background: rgba(102, 126, 234, 0.15);\n        color: var(--cui-body-color, #fff);\n\n        .detail-total-item {\n          background: rgba(33, 38, 49, 0.7);\n        }\n      }\n    }\n  }\n\n  // Table Styles\n  // ------------\n  .shipment-table,\n  .stock-table {\n    border-radius: $border-radius-base;\n    overflow: hidden;\n    box-shadow: $shadow-sm;\n    \n    thead {\n      th {\n        background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n        border: none;\n        padding: $spacing-md $spacing-lg;\n        font-weight: 700;\n        color: var(--cui-primary, #667eea);\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        font-size: 0.875rem;\n        position: relative;\n        \n        &::after {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: 2px;\n          background: var(--cui-primary, #667eea);\n          opacity: 0.3;\n        }\n        \n        html[data-coreui-theme=\"dark\"] & {\n          background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);\n          color: var(--cui-primary, #667eea);\n        }\n      }\n    }\n    \n    tbody {\n      tr {\n        transition: $transition-base;\n        \n        &:hover {\n          background: rgba(102, 126, 234, 0.02);\n          transform: scale(1.01);\n        }\n        \n        td {\n          padding: $spacing-md $spacing-lg;\n          border: none;\n          border-bottom: 1px solid rgba(102, 126, 234, 0.1);\n          vertical-align: middle;\n          color: var(--cui-body-color, #2c3e50);\n          font-weight: 500;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            color: var(--cui-body-color, #fff);\n            border-bottom-color: rgba(102, 126, 234, 0.2);\n          }\n          \n          .badge {\n            font-size: 0.75rem;\n            padding: $spacing-xs $spacing-sm;\n            font-weight: 600;\n            letter-spacing: 0.5px;\n            box-shadow: $shadow-sm;\n            transition: $transition-base;\n            \n            &:hover {\n              transform: scale(1.05);\n            }\n          }\n          \n          .icon {\n            color: var(--cui-secondary-color, #6c757d);\n            margin-right: $spacing-sm;\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-secondary-color, #8a93a2);\n            }\n          }\n        }\n        \n        &:last-child td {\n          border-bottom: none;\n        }\n      }\n    }\n  }\n\n  // Status Badges\n  // -------------\n  .status-badge {\n    font-weight: 600;\n    padding: $spacing-xs $spacing-sm;\n    font-size: 0.75rem;\n    letter-spacing: 0.5px;\n    box-shadow: $shadow-sm;\n    transition: $transition-base;\n    \n    &:hover {\n      transform: scale(1.05);\n    }\n  }\n\n  .swap-modal {\n    .modal-dialog {\n      max-width: min(820px, 94vw);\n      margin: 0.75rem auto;\n    }\n\n    .modal-content {\n      border: none;\n      border-radius: $border-radius-large;\n      overflow: hidden;\n      box-shadow: $shadow-lg;\n      background: #ffffff;\n      min-height: 560px;\n\n      html[data-coreui-theme=\"dark\"] & {\n        background: var(--cui-dark-bg, #212631);\n        border: 1px solid var(--cui-dark-border-subtle, #333);\n      }\n    }\n\n    .modal-header {\n      @include gradient-primary;\n      border-bottom: none;\n      padding: $spacing-md $spacing-lg;\n\n      .modal-title {\n        color: #fff;\n        font-weight: 700;\n        letter-spacing: 0.3px;\n      }\n\n      .btn-close {\n        filter: brightness(0) invert(1);\n      }\n    }\n\n    .modal-body {\n      padding: $spacing-lg;\n      background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.95) 100%);\n      display: flex;\n      flex-direction: column;\n      gap: $spacing-sm;\n\n      html[data-coreui-theme=\"dark\"] & {\n        background: linear-gradient(135deg, rgba(33, 38, 49, 0.95) 0%, rgba(44, 48, 52, 0.95) 100%);\n      }\n    }\n\n    .swap-modal-summary {\n      padding: $spacing-md;\n      border-radius: $border-radius-base;\n      border: 1px solid rgba(102, 126, 234, 0.2);\n      background: rgba(102, 126, 234, 0.08);\n\n      .swap-modal-summary-title {\n        color: var(--cui-primary, #667eea);\n        font-weight: 700;\n        font-size: 0.8rem;\n        margin-bottom: $spacing-xs;\n        text-transform: uppercase;\n        letter-spacing: 0.6px;\n      }\n\n      .swap-modal-summary-text {\n        color: var(--cui-body-color, #2c3e50);\n        font-weight: 600;\n        font-size: 0.9rem;\n\n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-body-color, #fff);\n        }\n      }\n\n      .swap-modal-readonly-field {\n        background-color: var(--cui-tertiary-bg, #dee2e6) !important;\n        border: 1px solid var(--cui-border-color, #cfd4da) !important;\n        color: var(--cui-body-color, #2c3e50) !important;\n        font-weight: 600;\n        pointer-events: none;\n        cursor: not-allowed;\n        opacity: 1;\n\n        &:focus {\n          box-shadow: none;\n          border-color: var(--cui-border-color, #cfd4da);\n        }\n\n        &:disabled {\n          background-color: var(--cui-tertiary-bg, #dee2e6) !important;\n          border-color: var(--cui-border-color, #cfd4da) !important;\n          color: var(--cui-body-color, #2c3e50) !important;\n          -webkit-text-fill-color: var(--cui-body-color, #2c3e50);\n          opacity: 1;\n        }\n\n        html[data-coreui-theme=\"dark\"] & {\n          background-color: var(--cui-dark-bg-subtle, #3a4049) !important;\n          border-color: var(--cui-dark-border-subtle, #5a6270) !important;\n          color: var(--cui-body-color, #fff) !important;\n\n          &:disabled {\n            background-color: var(--cui-dark-bg-subtle, #3a4049) !important;\n            border-color: var(--cui-dark-border-subtle, #5a6270) !important;\n            color: var(--cui-body-color, #fff) !important;\n            -webkit-text-fill-color: var(--cui-body-color, #fff);\n          }\n        }\n      }\n    }\n\n    .swap-modal-summary-grid {\n      display: grid;\n      grid-template-columns: 1fr;\n      gap: $spacing-sm;\n    }\n\n    .swap-modal-hint {\n      margin-bottom: $spacing-sm;\n      border-radius: $border-radius-base;\n      font-size: 0.85rem;\n      border: 1px solid rgba(13, 110, 253, 0.25);\n      background: rgba(13, 110, 253, 0.08);\n      color: var(--cui-body-color, #2c3e50);\n\n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-body-color, #fff);\n      }\n    }\n\n    .swap-modal-help {\n      font-size: 0.8rem;\n      color: var(--cui-secondary-color, #6c757d);\n\n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-secondary-color, #8a93a2);\n      }\n    }\n\n    .form-label {\n      font-weight: 600;\n      color: var(--cui-body-color, #2c3e50);\n      margin-bottom: $spacing-sm;\n\n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-body-color, #fff);\n      }\n    }\n\n    .form-control,\n    .form-select {\n      border-radius: $border-radius-base;\n      border: 1px solid rgba(102, 126, 234, 0.25);\n      padding: 0.65rem 0.8rem;\n\n      &:focus {\n        border-color: rgba(102, 126, 234, 0.7);\n        box-shadow: 0 0 0 0.15rem rgba(102, 126, 234, 0.2);\n      }\n    }\n\n    .swap-modal-footer {\n      border-top: 1px solid rgba(102, 126, 234, 0.15);\n      padding: $spacing-md $spacing-lg;\n      justify-content: flex-end;\n      gap: $spacing-sm;\n    }\n  }\n\n  // Empty State\n  // -----------\n  .empty-state {\n    text-align: center;\n    padding: $spacing-xxl $spacing-md;\n    \n    .empty-icon {\n      color: var(--cui-secondary-color, #6c757d);\n      margin-bottom: $spacing-lg;\n      opacity: 0.6;\n      animation: float 3s ease-in-out infinite;\n    }\n    \n    h5 {\n      color: var(--cui-body-color, #2c3e50);\n      margin-bottom: $spacing-sm;\n      font-weight: 600;\n      font-size: 1.25rem;\n    }\n    \n    p {\n      color: var(--cui-secondary-color, #6c757d);\n      margin: 0;\n      font-size: 1rem;\n      line-height: 1.6;\n    }\n    \n    html[data-coreui-theme=\"dark\"] & {\n      .empty-icon {\n        color: var(--cui-dark-border-subtle, #333);\n      }\n      \n      h5 {\n        color: var(--cui-body-color, #fff);\n      }\n      \n      p {\n        color: var(--cui-secondary-color, #8a93a2);\n      }\n    }\n  }\n\n  // Animations\n  // ----------\n  @keyframes pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.5; }\n  }\n  \n  @keyframes float {\n    0%, 100% { transform: translateY(0px); }\n    50% { transform: translateY(-10px); }\n  }\n  \n  @keyframes slideInUp {\n    from {\n      opacity: 0;\n      transform: translateY(30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  // Apply entrance animation\n  .order-summary-card,\n  .order-details-tabs {\n    animation: slideInUp 0.6s ease-out;\n  }\n\n  // Responsive Design\n  // -----------------\n  @media (max-width: 1200px) {\n    .order-summary-card .card-body .order-info-section .order-basic-info {\n      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    }\n    \n    .shipment-table,\n    .stock-table {\n      thead th,\n      tbody td {\n        padding: $spacing-sm $spacing-md;\n        font-size: 0.875rem;\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: $spacing-md;\n    \n    .order-details-header {\n      .header-left {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: $spacing-sm;\n        \n        .header-title h3 {\n          font-size: 1.5rem;\n        }\n      }\n    }\n    \n    .order-summary-card {\n      .card-body {\n        padding: $spacing-md;\n      }\n      \n      .order-info-section {\n        .order-header {\n          flex-direction: column;\n          gap: $spacing-md;\n          \n          .order-status-section {\n            align-self: flex-start;\n          }\n        }\n        \n        .order-basic-info {\n          grid-template-columns: 1fr;\n          gap: $spacing-sm;\n        }\n      }\n      \n      .order-summary-section {\n        padding: $spacing-md;\n      }\n    }\n    \n    .order-details-tabs {\n      .tabs-header {\n        .custom-tabs {\n          .custom-tab-link {\n            padding: $spacing-md $spacing-md;\n            font-size: 0.75rem;\n          }\n        }\n      }\n      \n      .tabs-content {\n        padding: $spacing-md;\n        \n        .info-card {\n          .info-card-header {\n            padding: $spacing-md;\n          }\n          \n          .card-body {\n            padding: $spacing-md;\n          }\n          \n          .info-grid {\n            grid-template-columns: 1fr;\n            gap: $spacing-md;\n          }\n        }\n        \n        .shipment-table,\n        .stock-table {\n          font-size: 0.875rem;\n          \n          thead th,\n          tbody td {\n            padding: $spacing-sm;\n            font-size: 0.8rem;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 480px) {\n    padding: $spacing-sm;\n    \n    .order-details-header .header-left .header-title h3 {\n      font-size: 1.25rem;\n    }\n    \n    .order-summary-card .card-body {\n      padding: $spacing-sm;\n    }\n    \n    .order-details-tabs .tabs-content {\n      padding: $spacing-sm;\n      \n      .shipment-table,\n      .stock-table {\n        font-size: 0.75rem;\n        \n        thead th,\n        tbody td {\n          padding: $spacing-xs;\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n\n  // Print styles\n  // ------------\n  @media print {\n    background: white !important;\n    \n    &::before {\n      display: none;\n    }\n    \n    .order-details-header .header-left .back-button {\n      display: none;\n    }\n    \n    .order-summary-card,\n    .order-details-tabs {\n      box-shadow: none;\n      border: 1px solid #ddd;\n    }\n    \n    .tabs-header {\n      background: #f8f9fa !important;\n      color: #333 !important;\n    }\n    \n    .shipment-table,\n    .stock-table {\n      box-shadow: none;\n      border: 1px solid #ddd;\n    }\n  }\n\n  // High contrast mode\n  // ------------------\n  @media (prefers-contrast: high) {\n    .order-summary-card,\n    .order-details-tabs {\n      border: 2px solid #000;\n    }\n    \n    .info-card {\n      border: 1px solid #666;\n    }\n    \n    .summary-item {\n      border-bottom-color: #333;\n    }\n    \n    .shipment-table,\n    .stock-table {\n      border: 1px solid #000;\n      \n      thead th,\n      tbody td {\n        border: 1px solid #666;\n      }\n    }\n  }\n\n  // Reduced motion\n  // --------------\n  @media (prefers-reduced-motion: reduce) {\n    *,\n    *::before,\n    *::after {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
